import React, {useEffect, useState} from "react";
import Baselining from "./Baselining.page";

function BaseliningImpactRating() {
    return <Baselining/>
}

export default BaseliningImpactRating;